
(function ($) {

    /**
     * Initialize Vidyard players within a modal when it opens
     */
    function initVidyardInModal($modal) {
        const $vidyardPlayer = $modal.find('.vidyard-player-embed');

        if ($vidyardPlayer.length > 0) {
            // Check if Vidyard API is loaded
            if (typeof window.VidyardV4 !== 'undefined' && typeof window.VidyardV4.init === 'function') {
                window.VidyardV4.init();
            } else {
                // Wait for Vidyard API to load
                let checkCount = 0;
                const checkInterval = setInterval(function () {
                    checkCount++;
                    if (typeof window.VidyardV4 !== 'undefined') {
                        window.VidyardV4.init();
                        clearInterval(checkInterval);
                    } else if (checkCount > 50) { // Stop checking after 5 seconds
                        clearInterval(checkInterval);
                    }
                }, 100);
            }
        }
    }

    /**
     * Clean up video players when modal closes
     */
    function cleanupVideoModals() {
        $(document).on('hidden.bs.modal', '.modal', function () {
            const $modal = $(this);

            // 1. HTML5 videos
            $modal.find('video').each(function () {
                this.pause();
                this.currentTime = 0;
            });

            // 2. YouTube
            $modal.find('iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]').each(function () {

                var src = $(this).attr('src');
                $(this).attr('src', '');
                $(this).attr('src', src);

            });

            // 3. Vimeo
            $modal.find('iframe[src*="vimeo.com"]').each(function () {
                this.contentWindow.postMessage(
                    JSON.stringify({ method: 'pause' }),
                    '*'
                );
            });

            // 4. Vidyard
            if (window.VidyardV4 && window.VidyardV4.players) {
                Object.values(window.VidyardV4.players).forEach(function (player) {
                    try {
                        player.pause();
                        player.seek(0);
                    } catch (e) { }
                });
            }
        });
    }

    /**
     * Initialize video modals when they open
     */
    function initVideoModals() {
        // Handle modal open events (including dynamically added modals)
        $(document).on('shown.bs.modal', '.modal', function () {
            const $modal = $(this);
            // Initialize Vidyard if video exists
            initVidyardInModal($modal);
        });
    }

    // Initialize on page load
    $(document).ready(function () {
        initVideoModals();
        cleanupVideoModals();
    });

    // Re-initialize when new content is loaded dynamically
    $(document).on('video-modals-ready', function () {
        initVideoModals();
    });

})(jQuery);

